import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to identify your personal meaning.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>Pepsi – Coca-Cola. Can you tell the difference? Which would you
                                                drink and why?</p>

                                            <div className="border_subtitle">Purpose and direction</div>
                                            <p>Both drinks are marketed at our values and lifestyle rather than
                                                on taste. Advertising (such as for these drinks), is full of
                                                consumer-focused messages, and it can be hard for us to filter
                                                out all the noise and come to an informed conclusion about what
                                                we really want.</p>


                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">The Pepsi Challenge</div>
                                                <p>In 2008, Michael Allen and his colleagues<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>1</sup></a> at the
                                                    University of Adelaide set out to test how our values affect
                                                    our perceptions. They gave participants either Pepsi or a
                                                    store-brand cola to drink. However, they lied to some of the
                                                    participants about which drink they had been given in order
                                                    to see if their values would bias their perception.</p>
                                                <p>Those who most strongly agreed that life should be full of
                                                    excitement thought that their cola – which they were told
                                                    was Pepsi – was tastier, whether or not they were actually
                                                    drinking Pepsi. This was essentially the effect of Pepsi’s
                                                    branding message of life being full of excitement and
                                                    enjoyment.</p>
                                                <p>This research may suggest that if you feel you share values
                                                    with something, then your perception of it is likely to be
                                                    different than someone who does not. This can be a flaw when
                                                    you consider that something such as fizzy pop in fact has no
                                                    such intrinsic values. Biases like these are important to
                                                    consider when you are trying to uncover personal
                                                    meaning.</p>
                                            </div>


                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}